import tribunalAPI from "api/tribunalAPi";
import {
  BodyConversionAudioActuacion,
  BodyLiberacionAudioActuacion,
  ResponseConversionAudioActuacionService,
  ResponseLiberacionAudioActuacionService
} from "interfaces/audioActuacion/audioActuacionInterfaces";

const postGenerarConversionAudioActuacion = async (
  params: BodyConversionAudioActuacion
) => {
  let url = `/conversion-audio-actuaciones/crear-conversion-actuacion?cveTipoActuacion=${params.cveTipoActuacion}&idActuacion=${params.idActuacion}`;
  return await tribunalAPI.post<ResponseConversionAudioActuacionService>(url);
};

const getLiberacionAudioActuacion = async (
    params: BodyLiberacionAudioActuacion
) => {
    let url = `/conversion-audio-actuaciones/obtener-liberacion-conversion-audio/${params.cveTipoActuacion}`;
    return await tribunalAPI.get<ResponseLiberacionAudioActuacionService>(url);
};

const getAudioConvertidoActuacion = async (params: BodyConversionAudioActuacion) => {
  let url = `/conversion-audio-actuaciones/obtener-conversion-audio-actuacion?idActuacion=${params.idActuacion}&cveTipoActuacion=${params.cveTipoActuacion}`;
  return await tribunalAPI.get(url);
}

export {
  postGenerarConversionAudioActuacion,
  getLiberacionAudioActuacion,
  getAudioConvertidoActuacion
};